import { brackets2dots, set } from "@app/common/utils/objectUtils";

export const constructObjectBySearchParams = <TResult extends { [key: string]: any }>(searchParams: URLSearchParams): TResult => {
    const entries = Array.from(searchParams.entries());

    const constructedObject = {} as TResult;

    entries.forEach(([key, value]) => {
        set(constructedObject, brackets2dots(key), value);
    });

    return constructedObject;
};
